export default {
    DOWNLOAD_SUCCESS: 'DOWNLOAD_SUCCESS',
    DOWNLOAD_FAILURE: 'DOWNLOAD_FAILURE',
    DOWNLOAD_RESET: 'DOWNLOAD_RESET',
    LOADING: 'DOWNLOADING'
}